<template>
  <v-container class="pa-0">
    <v-list-item
      v-for="(option, index) in options"
      :key="index"
      @click="optionDidSelected(index)"
    >
      <v-list-item-avatar
        class="rounded"
        :size="$vuetify.breakpoint.mdAndDown ? '40' : '50'"
        color="white"
      >
        <v-img :src="getSelectedItemImageForOption(option)" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="option.name" />
        <v-list-item-subtitle v-text="getSelectedItemNameForOption(option)" />
      </v-list-item-content>
    </v-list-item>
  </v-container>
</template>

<script>
  export default {
    name: 'OptionsList',

    props: {
      options: Array,
    },

    methods: {
      optionDidSelected (index) {
        if (index !== undefined && index < this.options.length) {
          this.$emit('optionDidSelected', this.options[index])
        }
      },

      getSelectedItemNameForOption (option) {
        const item = this.retrieveSelectedItemForOption(option)
        if (item && item.name) return item.name
        return this.localize('chooseOption')
      },

      getSelectedItemImageForOption (option) {
        const item = this.retrieveSelectedItemForOption(option)
        if (item && item.image) return item.image
        return require('@/assets/placeholder-option.png')
      },

      retrieveSelectedItemForOption (option) {
        if (option.is_theme) {
          const item = option.elements.find(element => element.is_selected)
          if (item && item !== undefined) return item
        }
        return option.selected_element
      },
    },
  }
</script>
